<template>
  <v-btn
    :color="color"
    :outlined="outlined ? outlined : false"
    @click="collapseButtonHandler"
  >
    {{ collapseButtonLabelValue }}
  </v-btn>
</template>

<script>
export default {
  props: [
    'color',
    'outlined',
    'state',
    'statesLabel'
  ],
  computed: {
    collapseButtonLabelValue: {
      get () {
        return this.statesLabel[this.state]
      }
    }
  },
  methods: {
    collapseButtonHandler () {
      this.$emit('click', this.state)
    }
  }
}
</script>
